import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { render } from 'react-dom';
import UIApplication from 'UIComponents/app/UIApplication';
import { createBrowserHistory } from 'history';
import Raven from 'Raven'; // I18n Configuration
// @ts-expect-error Library not migrated yet

import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import lang from 'i2l?query=sporks!../lang/en.lyaml'; // @ts-expect-error Library not migrated yet

import registerAllData from 'I18n/init/register/sync/registerAllData'; // @ts-expect-error Library not migrated yet

import { initAppTranslations } from 'I18n/init/setup/AppInit'; // Import extra I18n data

import 'I18n/init/data/currency';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales'; // Rhumb

import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4'; // Data fetching client

import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client'; // Configure the router

import { Router, useLocation } from 'react-router-dom';
import { getBaseUrl } from './utils/urls';
import Routes from './Routes';
import Layout from './components/Layout';
import { ThemeProvider } from './components/Theme';
import { UsageTracker } from './utils/tracking';
import { useEffect } from 'react';
import SurvicateSurveyEmbed from './components/Survicate';
import { getUserInfo } from './features/auth/authQueries';

const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
};

export default class App {
  constructor() {
    this.client = new DataFetchingClient({
      assumeImmutableResults: true
    });
  }

  // Kicks off the app. This is intentionally not in the constructor.
  start() {
    const I18nProvider = createStandardI18nProvider();
    const langAvailable = initAppTranslations([I18nProvider.register(lang), registerAllData(I18nProvider)]);
    getUserInfo(this.client).then(user => {
      I18nProvider.setLocale({
        locale: user.locale,
        langEnabled: user.lang_enabled
      });
      Raven.setUserContext({
        id: user.user_id.toString(),
        email: user.email
      });
      UsageTracker.init({
        userEmail: user.email
      });
      return langAvailable.then(() => {
        this.startUI();
      });
    }).catch(error => {
      if (error && error.networkError && error.networkError.status === 401) {
        I18nProvider.setLocale({
          locale: 'en',
          langEnabled: true
        });
        Raven.setUserContext({
          id: '1',
          email: 'a'
        });
        UsageTracker.init({
          userEmail: 'a'
        });
        return langAvailable.then(() => {
          this.startUI();
        });
      }

      Raven.captureException(error);
      return null;
    });
  }

  startUI() {
    const history = createBrowserHistory({
      basename: getBaseUrl()
    });
    render( /*#__PURE__*/_jsxs(UIApplication, {
      name: "connect-dot-com-ui",
      children: [/*#__PURE__*/_jsx(ThemeProvider, {
        children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
          client: this.client,
          children: /*#__PURE__*/_jsx(RhumbProvider, {
            history: historyAdapter(history),
            config: rhumbConfig,
            captureExceptions: true,
            children: /*#__PURE__*/_jsx(Router, {
              history: history,
              children: /*#__PURE__*/_jsxs(Layout, {
                children: [/*#__PURE__*/_jsx(ScrollToTop, {}), /*#__PURE__*/_jsx(Routes, {})]
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx(SurvicateSurveyEmbed, {})]
    }), document.getElementsByClassName('page')[0]);
  }

}